// extracted by mini-css-extract-plugin
module.exports = {"container":"table_container__rvdGr","body":"table_body__3QQz3","loader":"table_loader__2s5Se"};